import { Navigate, Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import SurveysTable from 'modules/surveys/components/Table/SurveysTable'
import UpsellPage from 'modules/surveys/pages/UpsellPage'
import surveys from 'modules/surveys/store/collections/v2/surveys'

function SurveysListPage() {
  const { getListPath } = useMarketplaceModulesPath()
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()
  const {
    moduleAvailabilities,
    upsellFlowEnabled,
    loading,
    canCreateTemplates,
    canSeeSmartSurveys,
  } = useEngagementContext()
  const surveysModuleAvailable = hasSurveysModule(moduleAvailabilities)
  const showUpsell = !surveysModuleAvailable && upsellFlowEnabled
  const { loading: surveysLoading } = useAsyncData(
    () =>
      surveysModuleAvailable
        ? surveys.fetch()
        : new Promise<void>((resolve) => {
            resolve()
          }),
    []
  )

  if (canSeeSmartSurveys) {
    return <Navigate to={navigation.engagement.smart_surveys.fullPath()} />
  }

  return (
    <ResponsivePage.Body
      loading={loading || surveysLoading}
      showHeader={false}
      error={null}
      authorized={employee?.hasRegularAccess}
      actions={{
        primary: canCreateTemplates
          ? [
              {
                variant: 'secondary',
                icon: 'settings',
                label: i18n.t('common.settings'),
                to: navigation.settings.surveys.fullPath(),
              },
            ]
          : [],
      }}
    >
      <Box gap="s48">
        {surveysModuleAvailable ? (
          <SurveysTable />
        ) : showUpsell ? (
          <UpsellPage />
        ) : (
          <Navigate to={getListPath()} />
        )}
      </Box>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default observer(SurveysListPage)
